import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import { Card, CardSection } from "cxa-components";
import { useSelector, useDispatch } from "react-redux";
import withMatchMediaProps from "@hocs/with-match-media-props";
import { formValueSelector, change } from "redux-form";
import { RadioButtonsFlat } from "cxa-form-field";
import MedicalHistoryAnswers from "./MedicalHistoryAnswers";
import { HdfDataContext } from "../index";
import { getValidations } from "../validations";

const MedicalHistory = ({
  label,
  isNarrowScreen,
  columns,
  question,
  deletionConfirmMsg,
  answers,
  ...props
}) => {
  const dispatch = useDispatch();
  const valueSelector = formValueSelector("GeneralHDF");
  const state = useSelector(state => state);
  const isReadOnly = useContext(HdfDataContext).isCompleted || false;
  const yesAnswer = valueSelector(state, "familyHistoryQuestionAnswer") === "Yes";
  const maxMemberIndex = state.genHDF.maxMemberHistory;
  const memberHistories = [];
  for (let i = 1; i <= maxMemberIndex; i++) {
    memberHistories.push("memberHistory_" + i);
  }
  const [historyState, setHistoryState] = useState({
    memberHistories,
    maxMemberIndex,
  });

  const addMemberHistory = () => {
    setHistoryState(prevState => ({
      memberHistories: [
        ...prevState.memberHistories,
        "memberHistory_" + (prevState.maxMemberIndex + 1),
      ],
      maxMemberIndex: prevState.maxMemberIndex + 1,
    }));
  };

  const updateFormValues = memberHistoryKey => {
    return (dispatch, getState) => {
      const state = getState();
      const formValues = state.form["GeneralHDF"].values || {};
      for (const key in formValues) {
        if (!key.startsWith(memberHistoryKey)) {
          dispatch(change("GeneralHDF", key, formValues[key]));
        } else {
          dispatch(change("GeneralHDF", key, ""));
        }
      }
    };
  };

  const removeMemberHistory = memberHistory => {
    const confirmed = confirm(deletionConfirmMsg);
    if (confirmed) {
      // Proceed with deletion
      setHistoryState(prevState => ({
        ...prevState,
        memberHistories: [...prevState.memberHistories.filter(history => history != memberHistory)],
      }));
      dispatch(updateFormValues(memberHistory));
    }
  };

  return (
    <Card className="hdf-card">
      <CardSection>
        <div className="section-header">
          <strong>{label}</strong>
        </div>
        <div style={{ width: "100%", padding: "0.5rem", fontSize: "1rem" }}>
          {question.label}
          <RadioButtonsFlat
            id={question.id}
            name={question.component.id}
            label={question.component.label}
            items={question.component.options}
            disabled={isReadOnly || question.component.readOnly}
            validate={[...getValidations(question.component.validation)]}
            inline={true}
          />
        </div>
        {yesAnswer &&
          historyState.memberHistories.map(memHistory => {
            return (
              <div
                key={memHistory}
                className="grid-container"
                style={{ gridTemplateColumns: `repeat(${isNarrowScreen ? 1 : columns}, 1fr)` }}
              >
                <MedicalHistoryAnswers
                  key={answers.id}
                  memberHistory={memHistory}
                  removeMemberHistory={removeMemberHistory}
                  allowDelete={memHistory !== "memberHistory_1"}
                  {...props}
                  {...answers}
                />
              </div>
            );
          })}
        {yesAnswer && !isReadOnly && (
          <div style={{ textAlign: "center", margin: "1rem 0" }}>
            <button className="link" type="button" onClick={addMemberHistory}>
              + Add Parent/Sibling
            </button>
          </div>
        )}
      </CardSection>
    </Card>
  );
};

MedicalHistory.propTypes = {
  label: PropTypes.string,
  isNarrowScreen: PropTypes.bool,
  columns: PropTypes.number,
  components: PropTypes.array,
  question: PropTypes.object,
  answers: PropTypes.object,
  deletionConfirmMsg: PropTypes.string,
};

export default withMatchMediaProps({
  isNarrowScreen: {
    maxWidth: 680,
  },
})(MedicalHistory);



// WEBPACK FOOTER //
// ./components/employee/gen-hdf-form/components/MedicalHistory.js